// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__DjJzo","vLegacy":"SelectSecondary_vLegacy__IiJEb","error":"SelectSecondary_error__46b7J","disabled":"SelectSecondary_disabled__1Dhoh"};